import "./scripts/menu";
import "./scripts/animations";
import "./scripts/partners";
import "./scripts/path";
import "./scripts/slider";
import "./scripts/things";
